import React from 'react';
import { getImageUrl } from '@src/utils/media-data';

/** Missing image data must not produce an empty or invalid img element. */
const OptionalImage = ({ src, alt = '', ...props }) => {
  const url = getImageUrl(src);
  return url ? <img {...props} src={url} alt={alt} /> : null;
};
export default OptionalImage;
